import type { Phrases } from '../common/Phrases.d';

import React from 'react';
import { Span, cn } from '../../../components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	SERVICES_FIELD_NAME,
	FIELD_VALUE_NUMBER_OF_PEOPLE_GOT_REACTIONS,
} from './constants';


export const NumberOfPeopleGotReactionsOtherTextField = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const label = phrases['notificationForm.services.numberOfPeopleGotReactionsOtherField.label'];
	return (
		<TextField
			className={cn({ flexGrow: 1 })}
			errorSummaryLabel={label}
			fullWidth
			label={<Span textSize='lg' weight='semiBold'>{label}</Span>}
			name={SERVICES_FIELD_NAME.NUMBER_OF_PEOPLE_GOT_REACTIONS_OTHER}
			showIf={
				({watch}) => watch({
					name: SERVICES_FIELD_NAME.NUMBER_OF_PEOPLE_GOT_REACTIONS,
				}) === FIELD_VALUE_NUMBER_OF_PEOPLE_GOT_REACTIONS.SEVERAL
			}
		/>
	);
};
